module.exports = __webpack_public_path__ + "img/pay-logo-mir.dc0ffa2e.svg";